import './Blankslate-f5a9755a.css';

var classes = {"Container":"prc-Blankslate-Container-XATLP","Blankslate":"prc-Blankslate-Blankslate-7GPW-","Description":"prc-Blankslate-Description-OGHRk","Heading":"prc-Blankslate-Heading-H4xby","Visual":"prc-Blankslate-Visual-PeTD-","Action":"prc-Blankslate-Action-SK5XS"};

export { classes as default };
